import { render, staticRenderFns } from "./AddressBook.vue?vue&type=template&id=64e7bf6c"
import script from "./AddressBook.vue?vue&type=script&lang=js"
export * from "./AddressBook.vue?vue&type=script&lang=js"
import style0 from "./AddressBook.vue?vue&type=style&index=0&id=64e7bf6c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports